// Firebase configuration for notifications
// This file handles Firebase messaging for push notifications

interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
}

// Firebase configuration for driveshield-d5a37 project
// ✅ Correct web app configuration from Firebase Console
const firebaseConfig: FirebaseConfig = {
  apiKey: 'AIzaSyCQ7M7TryAmXExAKqrKsGmvvwDkYI_8LfU',
  authDomain: 'driveshield-d5a37.firebaseapp.com',
  projectId: 'driveshield-d5a37',
  storageBucket: 'driveshield-d5a37.firebasestorage.app',
  messagingSenderId: '203050755191',
  appId: '1:203050755191:web:98822b78dec39ebaee5272',
  measurementId: 'G-LHBTF8CE3J',
};

// VAPID key for push notifications
const vapidKey =
  'BDEs1HLdUj2ma_CKfFRHrRtFE42tvgMagAoSiHJrN1GVUNmgfRbIVaJ2UtpT07_Bah1HlToPnBH-DO-7dcXda7k';

let messaging: any = null;
let app: any = null;

export const initializeFirebase = async () => {
  try {
    const firebaseApp = await import('firebase/app');
    const firebaseMessaging = await import('firebase/messaging');

    app = firebaseApp.initializeApp(firebaseConfig);
    messaging = firebaseMessaging.getMessaging(app);
    return true;
  } catch (error) {
    return false;
  }
};

export const requestNotificationPermission = async (): Promise<string | null> => {
  try {
    if (!messaging) {
      const initialized = await initializeFirebase();
      if (!initialized) {
        return null;
      }
    }

    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const firebaseMessaging = await import('firebase/messaging');
      const token = await firebaseMessaging.getToken(messaging, {
        vapidKey: vapidKey,
      });
      return token;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const onMessageListener = () => {
  return new Promise((resolve) => {
    if (!messaging) {
      resolve(null);
      return;
    }

    import('firebase/messaging')
      .then(({ onMessage }) => {
        onMessage(messaging, (payload: any) => {
          resolve(payload);
        });
      })
      .catch((_error) => {
        resolve(null);
      });
  });
};

export { messaging, firebaseConfig, vapidKey };
